module.exports = __webpack_public_path__ + "static/img/img-6.7821ebc7.png";